import { createSlice } from '@reduxjs/toolkit';

const authSlice = createSlice({
  name: 'auth',
  initialState: {
    user: null,
    userId: null,
    userType: null, // 'guardian' or 'child'
    loading: true,
    isAuthenticated: false,
  },
  reducers: {
    setUser: (state, action) => {
      const user = action.payload;
      state.user = user;
      state.userId = user?.id || null;
      state.isAuthenticated = !!user;
      state.loading = false;
    },
    setUserType: (state, action) => {
      state.userType = action.payload;
    },
    setLoading: (state, action) => {
      state.loading = action.payload;
    },
    clearAuth: (state) => {
      state.user = null;
      state.userId = null;
      state.userType = null;
      state.isAuthenticated = false;
      state.loading = false;
    },
  },
});

export const { setUser, setUserType, setLoading, clearAuth } =
  authSlice.actions;

// Selectors
export const selectUser = (state) => state.auth.user;
export const selectUserId = (state) => state.auth.userId;
export const selectUserType = (state) => state.auth.userType;
export const selectIsAuthenticated = (state) => state.auth.isAuthenticated;
export const selectAuthLoading = (state) => state.auth.loading;

export default authSlice.reducer;
